import Core from '../plugin-core-system/core.class.js';
import TranslatedLang from '../helper/translated-lang.helper.js';

export default class CsPhoneLinks extends Core {

  static options = {
    globalWrapperSelector: '.js-global-wrapper'
  };

  /**
   * Formats any given phone number into the format "0 1 2 3 4 5 6" while preserving the leading "+"
   * @param {string} phoneNumber - The phone number to format
   * @returns {string} - Formatted phone number
   *
   * Examples:
   *   +49 123-456-7890   -> + 4 9 1 2 3 4 5 6 7 8 9 0
   *   (0123) 456-789     -> 0 1 2 3 4 5 6 7 8 9
   *   00491234567890     -> 0 0 4 9 1 2 3 4 5 6 7 8 9 0
   *   123456789          -> 1 2 3 4 5 6 7 8 9
   */
  formatPhoneNumber(phoneNumber) {
    // Remove all non-numeric characters except "+"
    const cleanedNumber = phoneNumber.replace(/(?!^\+)[^0-9]/g, '');

    // Add a space between each digit
    return cleanedNumber.split('').join(' ');
  }

  /**
   * Adds ARIA labels to phone links for accessibility
   */
  initPhoneLinks() {
    const base = this;

    if (!base.el.hasAttribute('aria-label')) { // Skip if already labeled
      const rawPhoneNumber = base.el.getAttribute('href').replace('tel:', '');
      if (rawPhoneNumber) { // Ensures the phone number is valid
        const translatedStringObject = TranslatedLang.translatedLangConfig('links', 'postFixString');
        const ariaPrefixText = translatedStringObject.postFixString.phone;

        const formattedPhoneNumber = this.formatPhoneNumber(rawPhoneNumber);
        base.el.setAttribute('aria-label', `${ariaPrefixText} ${formattedPhoneNumber}`);
      }
    }
  }

  init() {
    this.initPhoneLinks();
  }
}
